import React, { useState, useEffect, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  createFilterOptions,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
  Typography,
  Divider,
  CardActionArea,
} from "@mui/material";
import ReactPlayer from "react-player";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { postExercise, uploadFile, getExerciseUrl } from "../services/backend";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const MediaCard = ({ currentRow, onClose, onUpdate }) => {
  const [exerciseDetail, setExerciseDetail] = useState({
    ...currentRow,
    // tags: currentRow?.tags?.map((tag) => ({ key: tag, label: tag })),
  });
  const difficulties = ["入門級", "進階級", "精英級"];
  const tags = [
    { key: "全程安坐", label: "全程安坐" },
    { key: "水瓶 x1", label: "水瓶 x1" },
    { key: "不需道具", label: "不需道具" },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const imageFileInputRef = useRef(null);
  // const [imageFile, setImageFile] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const videoFileInputRef = useRef(null);
  // const [videoFile, setVideoFile] = useState(null);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const theme = useTheme();
  // theme.palette.mode

  const filter = createFilterOptions();

  const updateImageUrl = async () => {
    const result = await getExerciseUrl({ exercise_id: exerciseDetail?.exercise_id, upload_type: "image" });
    setImageUrl(result?.data?.filename);
  };

  const updateVideoUrl = async () => {
    const result = await getExerciseUrl({ exercise_id: exerciseDetail?.exercise_id, upload_type: "video" });
    setVideoUrl(result?.data?.filename);
  };

  useEffect(() => {
    console.log(exerciseDetail);
    updateImageUrl();
    updateVideoUrl();
  }, [exerciseDetail]);

  return (
    <>
      <DialogTitle>{currentRow?.title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={4} sx={{ mt: 2 }}>
          {/* New Line */}
          <Grid item xs={4}>
            <TextField
              required
              fullWidth
              label="Title"
              value={exerciseDetail.title}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, title: evt.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              fullWidth
              // type="text"
              // inputProps={{
              //   inputMode: "numeric",
              // }}
              label="Duration"
              value={exerciseDetail.duration}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, duration: evt.target.value.replace(/[^0-9]/g, "") })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              fullWidth
              label="Calories"
              value={exerciseDetail.calories}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, calories: evt.target.value.replace(/[^0-9]/g, "") })}
            />
          </Grid>

          {/* New Line */}
          <Grid item xs={12}>
            <TextField
              label="Subtitle"
              fullWidth
              multiline
              maxRows={4}
              value={exerciseDetail.subtitle}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, subtitle: evt.target.value })}
            />
          </Grid>

          {/* New Line */}
          <Grid item xs={4}>
            <TextField
              required
              fullWidth
              label="Author"
              value={exerciseDetail.author}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, author: evt.target.value })}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              required
              fullWidth
              label="Trainer"
              value={exerciseDetail.trainer}
              onChange={(evt) => setExerciseDetail({ ...exerciseDetail, trainer: evt.target.value })}
            />
          </Grid>

          <Grid item xs={4} sx={{ display: "flex", justifyContent: "center", alignItem: "center" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={exerciseDetail.status === "published"}
                  onChange={(evt) =>
                    setExerciseDetail({ ...exerciseDetail, status: evt.target.checked ? "published" : "drafting" })
                  }
                />
              }
              label={exerciseDetail.status === "published" ? "Publish" : "Draft"}
            />
            {/* <Autocomplete
              maxWidth
              multiple
              options={statuses}
              inputValue={exerciseDetail.status}
              onInputChange={(evt, val) => {
                console.log(val);
              }}
              // sx={{ width: 300 }}
              renderInput={(params) => <TextField {...params} label="Status" />}
            /> */}
          </Grid>

          {/* New Line */}
          <Grid item xs={4}>
            <Autocomplete
              maxWidth
              options={difficulties}
              value={exerciseDetail.difficulty}
              renderInput={(params) => <TextField {...params} label="Difficulty" />}
              onChange={(evt, val) => {
                setExerciseDetail({ ...exerciseDetail, difficulty: val });
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <Autocomplete
              multiple
              options={tags}
              value={exerciseDetail.tags}
              getOptionLabel={(option) => {
                if (typeof option === "string") {
                  return option;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }
                return option.label;
              }}
              // filterSelectedOptions
              filterOptions={(options, params) => {
                let filtered = filter(options, params).filter(
                  (option) => !exerciseDetail.tags.map((tag) => tag.key).includes(option.key)
                );
                const { inputValue } = params;
                const isExisting = options.some((option) => inputValue === option.key);
                if (inputValue !== "" && !isExisting) {
                  filtered.push({ key: inputValue, label: `新增 ${inputValue}` });
                }
                return filtered;
              }}
              onChange={(evt, vals) => {
                console.log(vals);
                setExerciseDetail({ ...exerciseDetail, tags: vals });
              }}
              renderInput={(params) => <TextField {...params} label="Tag" />}
            />
          </Grid>
        </Grid>

        <Divider sx={{ m: 4 }} />

        <Grid container>
          {/* New Line */}
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)) }}
            >
              Image
            </Typography>
            <input
              type="file"
              ref={imageFileInputRef}
              style={{ display: "none" }}
              onChange={async (evt) => {
                setIsImageLoading(true);
                const file = evt.target.files[0];
                if (file) {
                  const result = await uploadFile({ file, exercise_id: exerciseDetail.exercise_id, upload_type: "image" });
                  if (result?.data?.filename) {
                    setImageUrl(result?.data?.filename);
                  } else {
                    setImageUrl(null);
                  }
                }
                setIsImageLoading(false);
              }}
            />
            <Button
              sx={{ minWidth: 128, minHeight: 128 }}
              onClick={() => imageFileInputRef.current.click()}
              loading={isImageLoading}
            >
              <VisuallyHiddenInput type="file" />
              {imageUrl ? <img style={{ maxWidth: 256 }} src={`/img/${imageUrl}`} /> : "Upload"}
            </Button>
          </Grid>

          {/* New Line */}
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)) }}
            >
              Video
            </Typography>
            <input
              type="file"
              ref={videoFileInputRef}
              style={{ display: "none" }}
              onChange={async (evt) => {
                setIsVideoLoading(true);
                const file = evt.target.files[0];
                if (file) {
                  const result = await uploadFile({ file, exercise_id: exerciseDetail.exercise_id, upload_type: "video" });
                  if (result?.data?.filename) {
                    setVideoUrl(result?.data?.filename);
                  } else {
                    setVideoUrl(null);
                  }
                }
                setIsVideoLoading(false);
              }}
            />
            <Button
              sx={{ minWidth: 128, minHeight: 128 }}
              loading={isVideoLoading}
              onClick={() => videoFileInputRef.current.click()}
            >
              <VisuallyHiddenInput type="file" />
              {videoUrl ? <ReactPlayer width="auto" url={`/video/${videoUrl}`} playing muted loop playsinline /> : "Upload"}
            </Button>
          </Grid>
        </Grid>

        <Divider sx={{ m: 4 }} />

        <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setIsLoading(true);
              console.log(exerciseDetail);
              const result = postExercise({ exerciseDetail });
              console.log(result);
              onUpdate();
              // setCurrentRow(null);
            }}
          >
            Update
          </Button>
        </CardActions>
      </DialogContent>
    </>
  );
};

export { MediaCard };
